/**
 * External dependencies
 */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */

import { requestCurrentDispatchIfNotRequested } from 'state/current-dispatch/actions';
import { getCurrentDispatch, requestingCurrentDispatch } from 'state/current-dispatch/selectors';
import PlanLoader from './plan-loader';
import Icon from 'components/icon';
import Money from 'components/money';
import PlanName from 'components/plan-name';
import DateTime from 'components/date-time';
import Coupon from 'components/coupon';
import { Stack, Box, Divider, Text } from '@towersystems/towersystems-design-system';
import DetailListItem from 'components/detail-list-item';
import SubscriptionStatus from 'components/subscription-status';
import Card from 'components/card';


/**
 * Style dependencies
 */
import './styles.scss';

const CurrentDispatchPlanCard = (props) => {
	let currentDispatch = props.currentDispatch;

	useEffect(() => {
		props.requestCurrentDispatch();
	}, []);

	if (!currentDispatch && !props.requesting) {
		return (
			<Card>
				<Card.Header heading='Plan details' />
				<Stack>
					<Card.Section>
						<DetailListItem label='Plan amount' />
					</Card.Section>
					<Card.Section>
						<DetailListItem label='Current billing period' />
					</Card.Section>
					<Card.Section>
						<DetailListItem label='Next billing date' />
					</Card.Section>
				</Stack>
			</Card>
		);
	}

	if (!currentDispatch && props.requesting) {
		return <PlanLoader />;
	}

	return (
		<Stack space='xxlarge'>
				
		    {currentDispatch.map((dispatchplan) => {
		    	return (<Card><Stack><Card.Section>
							<Box display='flex' padding='small' alignItems='center'>
								<Stack space='small'>
									<Box>
										<PlanName value={dispatchplan.subscription.plan_id} />
									</Box>
									<Box>
									    Price:
										<Money value={dispatchplan.subscription.plan_unit_price / 100} /> /{' '}
										{dispatchplan.subscription.billing_period} {dispatchplan.subscription.billing_period_unit}
						         	</Box>
						         	{dispatchplan.subscription.status == 'active' && (
						         	<Box>
									    Next Billing On <DateTime date={dispatchplan.subscription.next_billing_at} />
						         	</Box>
						         	)}

						         	{dispatchplan.subscription.addons && (
										<Box padding='small'>
											<Box marginBottom='medium'>
												<Text weight='medium' size='small'>
													Addons
												</Text>
											</Box>
											<Stack space='medium' dividers>
												{dispatchplan.subscription.addons.map(({ unit_price, quantity, amount, id }) => {
													return (
														<Box
															key={id}
															display='flex'
															alignItems='center'
															justifyContent='spaceBetween'
														>
															<Text size='small' padding='small'>
															    {id} {' '}
																<Money value={amount / 100} /> ( x {quantity})
															</Text>
														</Box>
													);
												})}
											</Stack>
										</Box>
								
								    )}

								    {dispatchplan.subscription.coupons && (
										<Box padding='small'>
											<Box marginBottom='medium'>
												<Text weight='medium' size='small'>
													Discounts
												</Text>
											</Box>
											<Stack space='medium' dividers>
												{dispatchplan.subscription.coupons.map(({ coupon_id }) => {
													return (
														<Box key={coupon_id}>
															<Coupon couponId={coupon_id}></Coupon>
														</Box>
													);
												})}
											</Stack>
										</Box>
									)}
									<Box>
										<SubscriptionStatus status={dispatchplan.subscription.status} />
									</Box>
									{dispatchplan.subscription.status == 'future' && (
									<Box>
										Subscription start date: 
										{<DateTime date={dispatchplan.subscription.start_date} format='Do MMM, YYYY' />}
						         	</Box>
						         	)}
						         	
								</Stack>
							</Box>
							
						</Card.Section></Stack></Card>)
		    })}
			
		</Stack>
	);
};

export default connect(
	(state) => ({
		currentDispatch: getCurrentDispatch(state),
		requesting: requestingCurrentDispatch(state),
	}),
	{
		requestCurrentDispatch: requestCurrentDispatchIfNotRequested,
	},
)(CurrentDispatchPlanCard);
